import { BillingServices } from '@/services/billingServices';
export default {
    namespaced: true,

    actions:{

        async getBillingDataAction (_, payload){
            let res = await BillingServices.getBillingDataAPI(payload);
            let data = res.data;
            return data;
        },
        async getInvoiceDataAction (_, val){
            let res = await BillingServices.getInvoiceDataAPI(val);
            let data = res.data;
            return data;
        }, 

        async sendInvoiceEmailDataAction (_, val){
            let res = await BillingServices.sendInvoiceEmailDataAPI(val);
            let data = res.data;
            return data;
        },

        async getOpenInvoicesAction (_, payload){
            let res = await BillingServices.getOpenInvoicesAPI(payload);
            let data = res.data;
            return data;
        },

        async downloadOpenInvoiceAction (_, id){
            let res = await BillingServices.downloadOpenInvoiceAPI(id);
            return res.data;
        },

        async getOpenInvoiceViewAction (_, id){
            let res = await BillingServices.getOpenInvoiceViewAPI(id);
            return res.data;
        },

        async getOpenInvoiceCountAction (){
            let res = await BillingServices.getOpenInvoiceCountAPI();
            return res.data;
        },
        
    }
}